/**
 * Pengiraan satu baris jualan.
 *
 * Fungsi ini digunakan oleh **peranti dan pelayan**. Kedua-dua pihak mesti menghasilkan
 * angka yang sama bit demi bit, kerana pelayan mengesahkan jumlah peranti semasa sync
 * (ADR-0002). Jangan mendua fungsi ini di tempat lain.
 *
 * Urutan (ADR-0005 §3):
 *   1. gross     = round_half_up(qty × unit_price)
 *   2. discount  = clamp(diskaun, 0, gross)
 *   3. net       = gross − discount
 *   4. tax       = inclusive ? net × r / (10000 + r) : net × r / 10000
 *   5. lineTotal = inclusive ? net : net + tax
 */
import { assertSen, sumSen } from './money.js';
import { assertMilliQty, mulQtyPrice } from './quantity.js';
import { assertRateBp, taxFromGross, taxFromNet } from './tax.js';
export function computeLine(input) {
    assertMilliQty(input.qtyMilli, 'kuantiti baris');
    if (input.qtyMilli < 0) {
        throw new RangeError('kuantiti baris tidak boleh negatif; pulangan/pembatalan ialah aliran berasingan');
    }
    assertSen(input.unitPriceSen, 'harga unit');
    if (input.unitPriceSen < 0) {
        throw new RangeError('harga unit tidak boleh negatif');
    }
    assertRateBp(input.taxRateBp);
    const grossSen = mulQtyPrice(input.qtyMilli, input.unitPriceSen);
    const requestedDiscount = input.discountSen ?? 0;
    assertSen(requestedDiscount, 'diskaun baris');
    if (requestedDiscount < 0) {
        throw new RangeError(`diskaun baris tidak boleh negatif, diterima ${requestedDiscount}`);
    }
    if (requestedDiscount > grossSen) {
        throw new RangeError(`diskaun baris (${requestedDiscount}) melebihi jumlah baris (${grossSen})`);
    }
    const netSen = grossSen - requestedDiscount;
    const taxSen = input.taxInclusive
        ? taxFromGross(netSen, input.taxRateBp)
        : taxFromNet(netSen, input.taxRateBp);
    const lineTotalSen = input.taxInclusive ? netSen : netSen + taxSen;
    return { grossSen, discountSen: requestedDiscount, netSen, taxSen, lineTotalSen };
}
/** Jumlah kasar bagi beberapa baris, tanpa cukai. */
export function sumGross(lines) {
    return sumSen(lines.map((line) => line.grossSen));
}
//# sourceMappingURL=line.js.map